// extracted by mini-css-extract-plugin
module.exports = {"popups-root":"_21cN2","popupsRoot":"_21cN2","popups-wrapper":"DPb1o","popupsWrapper":"DPb1o"};